export const LandingContent = {
    "heading": "Workshop on GeoAI for Autonomous Spatial Analysis",
    "subheading": "Organized by the Center for Geospatial Information Science at the University of Maryland",
    "description": "We are proud to present this workshop on GeoAI for Autonomous Spatial Analysis. This will be a 2-day event held within the Department of Geographical Sciences at the University of Maryland's discovery district. The event will consist of presentations, lightning talks, discussion sessions, and networking opportunities."
}

export const AboutContent = {
    "paragraph": ``
}

export const LocationContent = {
    "paragraph": "The Workshop on GeoAI for Autonomous Spatial Analysis will be held in room 325 of the Department of Geographical Sciences. The address is 4600 River Road, College Park, MD 20740 and is within the University of Maryland's discovery district, an intellectual hub that is home to cutting-edge research and pioneering companies. Please use the rear entrance and take the elevator to the third floor. The building has free parking in the back for those commuting locally."
}

export const speakers = [
    {
        "name": "Taylor Oshan",
        "image": "toshan.jpg",
        "affiliation": "The University of Maryland"
    },
    {
        "name": "Devika Jain",
        "image": "Devika_Jain.jpeg",
        "affiliation": "Harvard University, Center for Geographic Analysis",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1_jO_a-hV8d07b6wih6A-vSSwQCCB5FzA",
        "video": "https://drive.google.com/file/d/1MM4K-mM7jZpTX6oV1zlgzB_zdgZT-5JC/preview"
    },
    {
        "name": "Hongyu Zhang",
        "image": "Hongyu_Zhang.jpg",
        "affiliation": "University of Massachusetts Amherst",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1ZVvC0lq7L_8NOup7NP8kkdFXEPIOyygK",
        "video": "https://drive.google.com/file/d/1wjX274C2U60xW4MrFRX2nY5X2z1mlx0K/preview"
    },
    {
        "name": "Yue Lin",
        "image": "Yue_Lin.jpg",
        "affiliation": "University of Illinois Urbana-Champaign",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1rLC6AJQkPtawZaaUCpFQdskYPbDWx3AP",
        "video": "https://drive.google.com/file/d/1XrRfzx5-dcWEaTFj3ytQ_d49gPMU8_Q1/preview"
    },
    {
        "name": "Huan Ning",
        "image": "Huan_Ning.jpg",
        "affiliation": "The Pennsylvania State University",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1WC8kurtRBSjG6n03lU87ZoYAzWCHVRoX",
        "video": "https://drive.google.com/file/d/1TkE7MRtcpz5YQ-OGSu6HmX3vdM9-F_nm/preview"
    },
    {
        "name": "Arbaaz Muslim",
        "image": "Arbaaz_Muslim.jpg",
        "affiliation": "Google",
        "paper": "https://drive.google.com/file/d/1IO_YdfqP7ZGYeiuHtP3MmZxtzLOHmu_j/view?usp=sharing",
        "video": "https://drive.google.com/file/d/1vgY04xvy98AcpRHgxhg-kRH6GaQv3eKK/preview"
    },
    {
        "name": "Di Zhu",
        "image": "Di_Zhu.jpeg",
        "affiliation": "University of Minnesota",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1qKAvMPQZdng5uwp0Fx9wKe1EeQmnfowb",
        "video": "https://drive.google.com/file/d/1qC4DNB1Ss9pk9DATqBTKcKXJmgSMn3wv/preview"
    },
    {
        "name": "Ziqi Li",
        "image": "Ziqi_Li.jpg",
        "affiliation": "Florida State University",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1JY4AUJVT8-k8-O8XJpfBpA01JnxEBtQn",
        "video": "https://drive.google.com/file/d/1nkD6nmachfOu3P6ph6JUiltrhgI50XxM/preview"
    },
    {
        "name": "Gia Barboza-Salerno",
        "image": "Gia_Barboza_Salerno.jpg",
        "affiliation": "The Ohio State University",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1QyOldv3FXJqYUvgjhQZdS-NmDezVSdLG",
        "video": "https://drive.google.com/file/d/14yZHAa1j2C5yi3EMEohztD1J8lsQ3kpu/preview"
    },
    {
        "name": "Daniel Adams",
        "image": "Daniel_Adams.jpeg",
        "affiliation": "Oak Ridge National Laboratory",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1qge_g3ujrExJcvWcN-lhW5ujch1gC8DI",
        "video": "https://drive.google.com/file/d/1pF4A2_yYbRsjF9T9gyomFKzJsEw9-YME/preview"
    },
    {
        "name": "Mehak Sachdeva",
        "image": "Mehak_Sachdeva.jpg",
        "affiliation": "Florida State University",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1EIpZh2bHQzmipzLvO5xBGrBxcnOrvn1b",
        "video": "https://drive.google.com/file/d/1RIEnv3r5ZoyjgvvoViuA723KOivcXXbl/preview"
    },
    {
        "name": "Clinton Stipek",
        "image": "Clinton_Stipek.jpg",
        "affiliation": "Oak Ridge National Laboratory",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1z51SpRR2obSdA2SMHexjccgZoxxIf1Im",
        "video": "https://drive.google.com/file/d/150RHsvaOuudhE_Ptaywqx0g1ior4o-PN/preview"
    },
    {
        "name": "Wataru Morioka",
        "image": "Wataru_Morioka.jpg",
        "affiliation": "Salisbury University",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1u-UrgZtAx8YjaWf1JhsXCRTLrN6JbXw0",
        "video": "https://drive.google.com/file/d/1R1oY2RQiTfUqjL1sLzhL7z2GLd1nPIrN/preview"
    },
    {
        "name": "Ghermay Araya",
        "image": "Ghermay_Araya.jpg",
        "affiliation": "New Light Technologies",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1XnZWXN9ynicNKTnDFQod-10zmSeARUuM",
        "video": "https://drive.google.com/file/d/1RlqsLairDZ0HOkU_gn7Li1gbXHTasdaL/preview"
    },
    {
        "name": "Caglar Koylu",
        "image": "Caglar_Koylu.jpg",
        "affiliation": "University of Iowa",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1bKm7-bv0ECJRQiYBqb2RLwR8eGVs2B3y",
        "video": "https://drive.google.com/file/d/1gKwV8tV1EGdha7Vgdxjzhc2L2nMpu4ym/preview"
    },
    {
        "name": "Gengchen Mai",
        "image": "Gengchen_Mai.jpeg",
        "affiliation": "University of Texas at Austin",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1gIWOyPn5UqLA3i7ETxZCTINGnglicz4P",
        "video": "https://drive.google.com/file/d/1brg-J688fS2e1bdOcpXpstN-c6UgZRd1/preview"
    },
    {
        "name": "Songhua Hu",
        "image": "Songhua_Hu.png",
        "affiliation": "City University of Hong Kong",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1WKGcNWlkBkgVGXCNee_VFgzOuhox73d4",
        "video": "https://drive.google.com/file/d/1maDv3LyYNCBF1LXrYY0k0pBv4CO3Qb4C/preview"
    },
    {
        "name": "Wei Kang",
        "image": "Wei_Kang.jpg",
        "affiliation": "University of California Riverside",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1wNjj8Wt_kguFomuTzc0wlpKwGflJDPgi",
        "video": "https://drive.google.com/file/d/15zqr4dVoho1Phs7JlA7-y05SbYf5bZuo/preview"
    },
    {
        "name": "Luyu Liu",
        "image": "Luyu_Liu.jpg",
        "affiliation": "Auburn University",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1mnSQOMzMymkXEAZlnikTfdNA7e_JKeH2",
        "video": "https://drive.google.com/file/d/1DWeIn3DD16Pehz6jGSLI9NUOPW-vrrL8/preview"
    },
    {
        "name": "Debs Ghosh",
        "image": "Debarchana_Ghosh.jpg",
        "affiliation": "University of Connecticut",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1WMPYM6zNlIvrxQQrTEfXi0ERrsTMRuax",
        "video": "https://drive.google.com/file/d/1VcB0IqiHv-HWrmW-BYG-ISgeKpBy-VT2/preview"
    },
    {
        "name": "Shaowen Wang",
        "image": "Shaowen_Wang.jpg",
        "affiliation": "University of Illinois Urbana-Champaign",
        "video": "https://drive.google.com/file/d/1Tk1m6xjAnkIqbY6wJampZ0JcaZ7qTkf9/preview"
    },
    {
        "name": "Zhenlong Li",
        "image": "Zhenlong_Li.jpg",
        "affiliation": "Pennsylvania State University",
        "paper": "https://drive.google.com/file/d/1938UMa4aFmI5njnwIarNU1zieqjdsX81/view?usp=share_link",
        "video": "https://drive.google.com/file/d/1bp5w7Uqitothasz4FXUk8tLHx9gSM_4a/preview"
    },
    {
        "name": "Yao-Yi Chiang",
        "image": "Yao-Yi_Chiang.jpeg",
        "affiliation": "University of Minnesota",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1ljwPKZgFyFCwyJeJA3kV6dhGr1hzL0hr",
        "video": "https://drive.google.com/file/d/1Zx8vSxOxbsLBaJ5-orcxPnZg_1tx4MmX/preview"
    },
    {
        "name": "Jessica Breen",
        "image": "Jessica_Breen.jpg",
        "affiliation": "American University",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1VbU03fkUkCJ7uTOef9kT4PS3Fnf3HA3o",
        "video": "https://drive.google.com/file/d/1QKWY0VuglaKDDHcCD3umOxuDJJ-Sgnwe/preview"
    },
    {
        "name": "Peter Kedron",
        "image": "Peter_Kedron.jpg",
        "affiliation": "University of California Santa Barbara",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1sEy79g_6EKoPFfDAk4q6T2uMMUF9hxDB",
        "video": "https://drive.google.com/file/d/1K4LmOzVdIeCj_UbD8XqqPIn8WQ0nKO0H/preview"
    },
    {
        "name": "Meiliu Wu",
        "image": "Meiliu_Wu.jpg",
        "affiliation": "University of Glasgow",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=1xNpqedhHeh_K47BWKezRQaqHO-DwvZHI",
        "video": "https://drive.google.com/file/d/1iWVNGqEpf87fmcKNo34MDu0yuUIEk4NL/preview"
    },
    {
        "name": "Vanessa Frias-Martinez",
        "image": "Vanessa_Frias_Martinez.jpg",
        "affiliation": "University of Maryland",
        "paper": "https://drive.google.com/u/0/open?usp=forms_web&id=12BVnr3mJmommOXMII_ahaA__yXM0-1m2",
        "video": "https://drive.google.com/file/d/1uAxUgoziv0rCbeeDOFsQa_auFVq-z09L/preview"
    },
    {
        "name": "John Wilson",
        "image": "John_Wilson.jpg",
        "affiliation": "University of Southern California",
        "video": "https://drive.google.com/file/d/1GN2r_v1Jfn9gPSEH-YnWlqXSKO7XItlz/preview"
    },
    {
        "name": "Yiqun Xie",
        "image": "Yiqun_Xie.png",
        "affiliation": "University of Maryland",
        "video": "https://drive.google.com/file/d/1HnhFUkNgOrEgWvqF9KP8E3ZfjiMbBld8/preview"
    },
    {
        "name": "Jason Gilman",
        "image": "Jason_Gilman.jpeg",
        "affiliation": "Element 84",
        "video": "https://drive.google.com/file/d/1SZ16T1Hg2bx_bU57okSR6bdzN9WIR0xR/preview"
    },
    {
        "name": "Victor Irekponor",
        "image": "Victor_Irekponor.jpg",
        "affiliation": "University of Maryland",
        "volunteer": true
    },
    {
        "name": "Mengyu Liao",
        "image": "Mengyu_Liao.jpg",
        "affiliation": "University of Maryland",
        "volunteer": true
    },
    {
        "name": "Zhihao Wang",
        "image": "Zhihao_Wang.jpg",
        "affiliation": "University of Maryland",
        "volunteer": true
    },
    {
        "name": "Ruohan Li",
        "image": "Ruohan_Li.jpg",
        "affiliation": "University of Maryland",
        "volunteer": true
    },
    {
        "name": "Ruichen Wang",
        "image": "Ruichen_Wang.jpg",
        "affiliation": "University of Maryland",
        "volunteer": true
    },
    {
        "name": "Zhili Li",
        "image": "Zhili_Li.jpg",
        "affiliation": "University of Maryland",
        "volunteer": true
    },
    {
        "name": "Haley Mullen",
        "image": "Haley_Mullen.jpg",
        "affiliation": "University of Maryland",
        "volunteer": true
    },
    {
        "name": "Yingrui Zhao",
        "image": "Yingrui_Zhao.jpg",
        "affiliation": "University of Maryland",
        "volunteer": true
    },
]

// FAQ Content

export const FAQContent = [
    {
        "question": "What is the best way to travel to the event hotel?",
        "answer": "<a href='https://www.thehotelumd.com' target='_blank' rel='noreferrer' style='color: #039876; font-weight: bold;'>The Hotel at UMD</a> is located at <a href='https://maps.google.com/?q=7777+Baltimore+Ave,+College+Park,+MD' target='_blank' rel='noreferrer' style='color: #039876; font-weight: bold;'>7777 Baltimore Ave</a> in College Park, MD. For those flying, there are three airports in the area - Dulles (IAD), Baltimore (BWI), and Washington (DCA). Rideshare or Taxi is definitely the most convenient and fastest way to get to College Park. It is also possible to take the metro from DCA or IAD to College Park, though both require a transfer to the green/yellow line. The College Park metro station is still about a mile from the hotel, so a short rideshare from there is necessary."
    },
    {
        "question": "How do I get from the hotel to the event and back?",
        "answer": "Each morning a 10-seat van will run shuttles to the workshop venue starting at 8:10am. The venue is about 5-6 minutes away, so shuttle rounds will continue around 8:25am, and 8:40. The van will be available to return to the hotel at 5:00pm on Sunday and around 4:30pm on Monday. There will also be some UMD team members available on site and available to help shuttle participants."
    },
    {
        "question": "How long should I plan to speak for?",
        "answer": "Lightning talk slots are 10 minutes inclusive of Q&A, so please plan to talk for 8-9 minutes if you would like to have Q&A outside of the dedicated discussion sessions. Similarly, longer presentation slots (of which there are only a handful) are 20 minutes inclusive of Q&A, so please plan to talk for 17-18 minutes if you would like to have Q&A outside of the dedicated discussion sessions."
    },
    {
        "question": "Should I worry about food and refreshments?",
        "answer": "No, there is a continental breakfast available at the hotel. Coffee, snacks, and other refreshments will be available on site throughout both days, as well as catered lunches. A group dinner is planned at Grillmarx (in The Hotel) at 7:00pm on Sunday evening. There will be a happy hour at Grillmarx from 6:00pm-7:00pm before the dinner, which is generously sponsored by New Light Technologies. For those staying in College Park on Monday evening, dinner will be self-organized."
    },
]
